import React from "react";
import { useSelector } from "react-redux";
import Fromcontainer from "./Fromcontainer";
import Productcart from "./Productcart";

function Home() {
  const Products = useSelector((state) => state.products);
  return (
    <main className="py-16">
      <div className="productWrapper">
        <div className="productContainer" id="lws-productContainer">
          {Products.length === 0 ? (
            <h1 className="font-bold text-xl">Product list is empty</h1>
          ) : (
            Products.map((item, index) => (
              <Productcart key={index} item={item} />
            ))
          )}
        </div>
        <div>
          <Fromcontainer />
        </div>
      </div>
    </main>
  );
}

export default Home;
